import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useSearchResultsContext } from "../../context/searchResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { showResults } = useSearchResultsContext();

    if (showResults) {
        return null;
    }

    return <>{children}</>;
};

export { Base };
